/**
 * @module app.bdc.reports.bundleNapElectronicSignatureCtrl
 */

let moment = require('moment');
    function BundleNapElectronicSignatureCtrl($rootScope, $scope, $window) {
        var self = {};
        if (!$rootScope.order) {
            return $scope.goTo('/bdc/list');
        }

        self.client = $rootScope.order.client;
        self.order = $rootScope.order;

        /**
         * Is TPE option ?
         * @return {Boolean}
         */
        self.isTPE = function isTPE() {
            for (var i = 0; i < self.order.options.length; i++) {
                if (
                    self.order.options[i].optionType.code === 'TPE' ||
                    self.order.options[i].optionType.code === 'LADDITION_TPE'
                ) {
                    return true;
                }
            }
        };

        // Modification du title de la page pour l'impression en PDF
        $window.document.title =
            self.client.lastName.replace(' ', '-') +
            '_' +
            self.client.firstName +
            '_' +
            'BonDeCommande' +
            '_' +
            moment().format('YYYYMMDD');


        return self;
    }

    BundleNapElectronicSignatureCtrl.$inject = ['$rootScope', '$scope', '$window'];

    angular
        .module('app.bdc.reports.bundleNapElectronicSignatureCtrl', [])
        .controller('BundleNapElectronicSignatureCtrl', BundleNapElectronicSignatureCtrl);

